<div class="row">
  <div class="col-sm-12">
    <section class="panel">
      <app-page-title title="Edit Payment Type" [loading]="isLoading"></app-page-title>

      <div class="panel-body">
        <form class="form-horizontal" (ngSubmit)="edit()" ngNativeValidate>
          <app-payment-type-form [paymentType]="paymentType" *ngIf="paymentType"></app-payment-type-form>
        </form>
      </div>
    </section>
  </div>
</div>
